import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const affirmationImporterSelectors = importerSelectors(
  'affirmation.importer',
);

export default affirmationImporterSelectors;
